var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 25,
    width: 38,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.478 24.556H4.689a4.105 4.105 0 01-4.106-4.105V4.662A4.106 4.106 0 014.69.556h28.789a4.105 4.105 0 014.105 4.106V20.45a4.105 4.105 0 01-4.105 4.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069AA",
    d: "M20.545 19.629c3.897.019 7.455-3.178 7.455-7.067 0-4.253-3.558-7.192-7.455-7.191H17.19C13.246 5.37 10 8.31 10 12.561c0 3.891 3.247 7.087 7.19 7.068h3.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.687 16.349V8.626a4.141 4.141 0 012.657 3.862 4.144 4.144 0 01-2.657 3.861m-5.617-3.861a4.144 4.144 0 012.655-3.861v7.72a4.142 4.142 0 01-2.655-3.86m4.136-6.526a6.527 6.527 0 10.004 13.054 6.527 6.527 0 00-.004-13.055"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3EAED",
    d: "M34.075 1A2.928 2.928 0 0137 3.925v17.15A2.928 2.928 0 0134.075 24H3.925A2.928 2.928 0 011 21.075V3.925A2.928 2.928 0 013.925 1h30.15zm0-1H3.925A3.925 3.925 0 000 3.925v17.15A3.925 3.925 0 003.925 25h30.15A3.925 3.925 0 0038 21.075V3.925A3.925 3.925 0 0034.075 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa5);
export default __webpack_public_path__ + "static/media/visa-5.a134022d4029f5bc8ab75dfd2fa30bf3.svg";
export { ForwardRef as ReactComponent };